import InboxLeft from "./inboxLeft";
import InboxRight from "./inboxRight";

export default function InputBody() {
  return (
    <div
      className="BAR1 || w-full h-calc-u5  || bg-white  
      || text-left text-black222 || 7:flex    "
    >
      <InboxLeft />
      <InboxRight />
    </div>
  );
}
